// src/utils/livekitToken.js
const BACKEND_URL = process.env.REACT_APP_LIVEKIT_BACKEND || 'http://localhost:5000';

export async function getLiveKitToken(roomName, participantName) {
  try {
    const response = await fetch(`${BACKEND_URL}/api/livekit-token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ roomName, participantName }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Token request failed');
    }

    const data = await response.json();
    return data.token;
  } catch (err) {
    console.error('Failed to get LiveKit token:', err);
    throw err;
  }
}